import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DISTRIBUTION_CENTER_ID, FRAC_ID } from '~lmo/lmo-routing.constants';
import { RouterStateService } from '~services/router-state.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo',
  styleUrls: ['./lmo.component.scss'],
  templateUrl: './lmo.component.html',
})
export class LmoComponent implements OnInit {
  public showNavBar$: Observable<boolean>;
  constructor(private routerState: RouterStateService) {}

  public ngOnInit() {
    this.showNavBar$ = combineLatest([
      this.routerState.listenForParamChange$(FRAC_ID),
      this.routerState.listenForParamChange$(DISTRIBUTION_CENTER_ID),
    ]).pipe(
      map(([fracId, distributionCenterId]) => {
        return !!!fracId && !!!distributionCenterId;
      }),
    );
  }
}
